import React, {FC, ReactNode} from "react";
import {usePermissions} from "../../../resources/PermissionsHook";
import {useNavigate} from "react-router-dom";
import {Card} from "../../../../../lib/src/components/Card";
import {Button} from "../../../../../lib/src/components/form/Button";
import {SettingsContainer} from "../SettingsPage";

export const LogsLink: FC<{}> = () => {
  const { canAccessLogs } = usePermissions()
  const navigate = useNavigate()
  if (! canAccessLogs) {
    return <></>
  }
  return <SettingsContainer title={"Logboek"} description={"Het logboek bevat alle acties die in het systeem worden uitgevoerd. Zowel door gebruikers als door het systeem zelf."}>
    <Card title={'Systeem logs'}>
      <Button type={"primary"} size={'sm'} onClick={() => navigate('/logs')} text={'Systeem logs bekijken'} />
    </Card>
    <div className={'h-5'}></div>
    <Card title={'Mail logs'}>
      <Button type={"primary"} size={'sm'} onClick={() => navigate('/settings/notification_logs')} text={'Mail logs bekijken'} />
    </Card>
  </SettingsContainer>
}